import GestionCautionPage from "../../modules/iframes/GestionCautionPage";
// import WebServicePage from "../../modules/iframes/WebServicePage";
import ConsultationTitres from "../../modules/TI/ui/ConsultationTitres";
import ReponseDomiciliationBanque from "../../modules/TI/ui/Details/ReponseDomiciliationBanque";
import GestionTitres from "../../modules/TI/ui/GestionTitres";
import ParametresDeCompte from "../../modules/TI/ui/ParametresDeCompte";
import TiHistorique from "../../modules/TI/ui/TiHistorique";
import TitreDetail from "../../modules/TI/ui/TitreDetail";
import {
  CONSULTATION_TITRES_PAGE,
  GESTION_CAUTION_PAGE,
  GESTION_TITRES_PAGE,
  WEB_SERVICE_PAGE,
} from "../constants/routerConstants";

const routesConfig = [
  {
    path: GESTION_TITRES_PAGE,
    component: GestionTitres,
    roles: ["ROLE_VUPORTUARIA_BANCO", "ROLE_VUPORTUARIA_ADMIN"],
  },
  {
    path: CONSULTATION_TITRES_PAGE,
    component: ConsultationTitres,
    roles: ["ROLE_VUPORTUARIA_BANCO", "ROLE_VUPORTUARIA_ADMIN"],
  },
  {
    path: "/titreDetail/:id",
    component: TitreDetail,
    roles: ["ROLE_VUPORTUARIA_BANCO", "ROLE_VUPORTUARIA_ADMIN"],
  },
  {
    path: "/changementmdp",
    component: ParametresDeCompte,
    roles: [
      "ROLE_VUPORTUARIA_BANCO",
      "ROLE_VUPORTUARIA_ADMIN",
      "ROLE_VUPORTUARIA_ANP",
    ],
  },
  {
    path: "/tihistorique/:id",
    component: TiHistorique,
    roles: ["ROLE_VUPORTUARIA_BANCO", "ROLE_VUPORTUARIA_ADMIN"],
  },
  {
    path: "/reponse-domiciliation-banque/:id",
    component: ReponseDomiciliationBanque,
    roles: ["ROLE_VUPORTUARIA_BANCO"],
  },
  {
    path: GESTION_CAUTION_PAGE,
    component: GestionCautionPage,
    roles: ["ROLE_VUPORTUARIA_BANCO", "ROLE_VUPORTUARIA_ADMIN"],
  },
  // {
  //   path: WEB_SERVICE_PAGE,
  //   component: WebServicePage,
  //   roles: ["ROLE_VUPORTUARIA_BANCO"],
  // },
];

export default routesConfig;
